const siteConfig = {
  eventLinks: [
    {
      name: 'Meeting minutes (Convention)',
      url:
        'https://drive.google.com/drive/folders/1-HiMOnSkSCTUhp2lj66HhbheFdhEBuUp?usp=sharing'
    },
    {
      name: 'Meeting minutes (Senior & Group Leaders)',
      url:
        'https://drive.google.com/drive/folders/1I0ygWxcXRm4LS_fV9NQZJwDoBu0Egh9h?usp=sharing'
    },
    {
      name: 'Dream Lab access',
      url: 'http://innowing.hk/dreamlab'
    },
    {
      name: 'RoboMaster Registration',
      url:
        'https://registration.robomaster.com/registration-center?locale=en-US'
    }
  ],
  accessLinks: [
    {
      name: 'Rules for competition (Simplified Chinese)',
      url:
        'https://rm-static.djicdn.com/documents/13194/aaac21da8c4dd1571140481712985175.pdf'
    },
    {
      name: 'Manual (Simplified Chinese)',
      url:
        'https://rm-static.djicdn.com/documents/13194/bebcb739dca6d1571140507545486210.pdf'
    },
    {
      name: 'Manufaction Standard (Simplified Chinese)',
      url:
        'https://rm-static.djicdn.com/documents/13194/fbedfad7c46331571140565128969335.pdf'
    },
    {
      name: 'Collection of DJI officlial documents (English)',
      url:
        'https://www.robomaster.com/en-US/resource/pages/1039?type=announcementSub'
    },
    {
      name: 'Team Affairs and Regulations',
      url:
        'https://drive.google.com/open?id=1OBd6nw31blZGxLcRmkzbCnztfEZwy4AWWx2j6_eTL5I'
    },
    {
      name: 'Financial statements',
      url:
        'https://drive.google.com/open?id=1J05eWTD7y9Jt1VzQHdHYVt1pkp5oz1eTBbLMkMA7pm8'
    },
    {
      name: 'Template for purchase request',
      url:
        'https://drive.google.com/open?id=1A-QA_THSsgJN-zibMln1ZSb9XpFO2s92dZWQwSdUgL0'
    },
    {
      name: 'RoboMaster BBS',
      url: 'https://bbs.robomaster.com/'
    }
  ],
  trainingLinks: [
    {
      name: 'Training slides (Automation)',
      url: 'https://drive.google.com/open?id=16y4vVvXjW33mFP5SwWkAKSvfLflkAnyt'
    },
    {
      name: 'Training slides (Algorithm)',
      url: 'https://drive.google.com/open?id=1UGnLtL8wNPMVSwC4me8EH1kOz-rQYZ8q'
    },
    {
      name: 'Training slides (Hardware)',
      url: 'https://drive.google.com/open?id=19sIZD_lrCZITLZjDE9myT8sF9NjVK4jW'
    },
    {
      name: 'Training slides (ME & EVCT)',
      url: 'https://drive.google.com/open?id=1-YfaH-Xxfpw4iBlXxppJExYd_AMYyhmM'
    },
    {
      name: 'Training slides (FBW)',
      url: 'https://drive.google.com/open?id=1XGXWkktYECIifY2fPhyGD2ivkYitXDvq'
    },
    {
      name: 'Training code repo (Algorithm)',
      url: ''
    },
    {
      name: 'Training code repo (Automation)',
      url: 'https://github.com/EE-LiuYunhao/HKURoboMasterTraining'
    },
    {
      name: 'Training code repo (FBW)',
      url: ''
    }
  ],
  rAndDLinks: [
    {
      name: 'RoboMaster BBS',
      url: 'https://bbs.robomaster.com/'
    },
    {
      name: 'Automation 2019 code',
      url: 'https://github.com/HKURoboMaster/automation_2019'
    },
    {
      name: 'Automation 2018 code',
      url: 'https://github.com/HKURoboMaster/automation_2018'
    },
    {
      name: 'Automation 2020 code (Infantry)',
      url: 'https://github.com/HKURoboMaster/automation_2019'
    },
    {
      name: 'Automation 2020 code (Hero)',
      url: ''
    },
    {
      name: 'Automation 2020 code (Sentry)',
      url: ''
    },
    {
      name: 'Automation 2020 code (Engineer)',
      url: ''
    },
    {
      name: 'FBW software sets repo',
      url: ''
    },
    {
      name: 'Algorithm (Computer vision) code repo',
      url: 'https://github.com/HKURoboMaster/cv_2019'
    },
    {
      name: 'ME design models',
      url: ''
    },
    {
      name: 'Requirements sheet (Infantry)',
      url:
        'https://drive.google.com/open?id=177604OMZDhJo1_kLVJ3llQI8r01na8DvQfQDHoVc4K0'
    }
  ],
  managementLinks: [
    {
      name: 'Member lists',
      url: 'https://drive.google.com/open?id=1OHZJ3ahfCYilcCd9wr9fMJfzoMTUJlBv'
    },
    {
      name: 'Accounting materials',
      url: 'https://drive.google.com/open?id=1odI5Wlk7KvGTm-JoF4gpTvbkzt6BjBX0'
    },
    {
      name: 'Team inventories',
      url:
        'https://drive.google.com/open?id=1sI_mou2Lykv726ORdxuZewcbtVo9bzX2JM5BbPd_iH8'
    },
    {
      name: 'Team Affairs and Regulations',
      url:
        'https://drive.google.com/open?id=1OBd6nw31blZGxLcRmkzbCnztfEZwy4AWWx2j6_eTL5I'
    },
    {
      name: 'Financial statements',
      url:
        'https://drive.google.com/open?id=1J05eWTD7y9Jt1VzQHdHYVt1pkp5oz1eTBbLMkMA7pm8'
    },
    {
      name: 'Template for purchase request',
      url:
        'https://drive.google.com/open?id=1A-QA_THSsgJN-zibMln1ZSb9XpFO2s92dZWQwSdUgL0'
    }
  ]
};

export default siteConfig;
